(function ($, window) {
    $(function () {
        var $wrapper = $(".js-enquiry-docking-bar");
        var $verticalEnquiryForm = $(".enquiry-form.vertical");
        var $horizontalEnquiryForm = $(".enquiry-form.horizontal");

            $(window).on('load', function() {
                if (!$verticalEnquiryForm.isInViewport()) {
                    $wrapper.removeClass('hidden');
                }
            });

            $(window).on('scroll', function () {
                $wrapper.toggleClass('hidden', $verticalEnquiryForm.isInViewport());
            });


            $('a.csn-btn', $wrapper).click(function() {
                $('html, body').animate({
                    scrollTop: $horizontalEnquiryForm.offset().top - 140
                }, 750);
            });

            $.fn.isInViewport = function() {
                var elementTop = $(this).offset().top;
                var elementBottom = elementTop + $(this).outerHeight();

                var viewportTop = $(window).scrollTop();
                var viewportBottom = viewportTop + $(window).height();

                return elementBottom > viewportTop && elementTop < viewportBottom;
            }
        });
})(jQuery, window);